/**
 * The edit dialogs prefill the reason with "<what> edited: " and ask for
 * something after it. A reason counts when there is text beyond the prefill —
 * or any text at all if the person cleared the prefill and wrote their own.
 */
export function changeReasonGiven(reason: string, prefill: string): boolean {
  const typed = reason.trim()
  if (!typed) return false
  const bare = prefill.trim().replace(/:$/, '')
  return typed !== bare && typed !== `${bare}:`
}

/** The reason without its prefill, for a build whose reason line adds "<what> edited: " itself. */
export function changeReasonNote(reason: string, prefill: string): string {
  const typed = reason.trim()
  const lead = `${prefill.trim().replace(/:$/, '')}:`
  return typed.startsWith(lead) ? typed.slice(lead.length).trim() : typed
}
